<template>
  <a
    :key="channel.name"
    :href="channel.url"
    :aria-label="channel.label"
    target="_blank"
    class="group focus:outline-hidden"
  >
    <div
      :class="
        useBrandColor
          ? [
              'flex h-9 w-9 items-center justify-center rounded-full border-2 border-white/50 outline-offset-4 group-focus:border-0 group-focus:outline group-focus:outline-2 ',
              iconClasses(channel.name),
            ]
          : 'outline-offset-4 group-focus:outline group-focus:outline-2 group-focus:outline-current'
      "
    >
      <component
        :is="iconComponent(channel.name)"
        :class="useBrandColor ? 'h-5 w-5' : 'h-6 w-6'"
        :fill="useBrandColor ? 'white' : 'currentColor'"
        aria-hidden="true"
      />
    </div>
  </a>
</template>

<script setup>
import IconFacebookCircle from '../icons/IconFacebookCircle.vue'
import IconInstagram from '../icons/IconInstagram.vue'
import IconLinkedinCircle from '../icons/IconLinkedinCircle.vue'
import IconTwitterCircle from '../icons/IconTwitterCircle.vue'
import IconTiktokCircle from '../icons/IconTiktokCircle.vue'
import IconYoutube from '../icons/IconYoutube.vue'
import IconWhatsappCircle from '../icons/IconWhatsappCircle.vue'
import IconGlassdoor from '../icons/IconGlassdoor.vue'

defineProps({
  channel: {
    type: Object,
    required: true,
  },
  useBrandColor: {
    type: Boolean,
    default: true,
  },
})

function iconComponent(channel) {
  const map = {
    facebook: IconFacebookCircle,
    twitter: IconTwitterCircle,
    linkedin: IconLinkedinCircle,
    instagram: IconInstagram,
    youtube: IconYoutube,
    glassdoor: IconGlassdoor,
    whatsapp: IconWhatsappCircle,
    tiktok: IconTiktokCircle,
  }
  return map[channel]
}
function iconClasses(channel) {
  const map = {
    facebook:
      'bg-facebook hover:bg-facebook-600 group-focus:bg-facebook-600 group-focus:outline-facebook-600',
    twitter:
      'bg-twitter hover:bg-twitter-800 group-focus:bg-twitter-800 group-focus:outline-twitter-800',
    linkedin:
      'bg-linkedin hover:bg-linkedin-600 group-focus:bg-linkedin-600 group-focus:outline-linkedin-600',
    instagram:
      'bg-instagram hover:bg-instagram-600 group-focus:bg-instagram-600 group-focus:outline-instagram-600',
    youtube:
      'bg-youtube hover:bg-youtube-600 group-focus:bg-youtube-600 group-focus:outline-youtube-600',
    glassdoor:
      'bg-glassdoor hover:bg-glassdoor-600 group-focus:bg-glassdoor-600 group-focus:outline-glassdoor-600',
    whatsapp:
      'bg-whatsapp hover:bg-whatsapp-600 text-white inline lg:hidden group-focus:bg-whatsapp-600 group-focus:outline-whatsapp-600',
    tiktok:
      'bg-tiktok hover:bg-tiktok-800 group-focus:bg-tiktok-800 group-focus:outline-tiktok-800',
  }
  return map[channel]
}
</script>
